import React from 'react';
import { CreateReport } from '../../../components';
import { useAnomalies } from '../../../hooks/theme.hook';
import { paths } from '../../../routes';
import * as Yup from 'yup';

export const SecurityForms: React.FC = () => {
  const { selectedAnomalyType, anomalyTypes, anomalies, handleOnSelectAnomalyType } = useAnomalies(
    '' + paths.security.themeShortCode
  );

  return (
    <CreateReport
      initialValues={{
        fieldReportsDto: {},
      }}
      themeShortCode={paths.security.themeShortCode || ''}
      otherFields={{
        anomalyTypeShortCode: {
          type: 'select',
          label: "Type d'anomalie",
          grid: 6,
          options: anomalyTypes,
        },
        anomalyShortCode: {
          type: 'select',
          label: 'Anomalie',
          grid: 6,
          options: anomalies,
          disabled: !selectedAnomalyType,
        },
        'fieldReportsDto.comment': {
          type: 'text',
          label: 'Exposer les faits',
          multiline: true,
          rows: 4,
          rowsMax: 15,
        },
      }}
      onChange={handleOnSelectAnomalyType}
      validationSchema={Yup.object({
        anomalyTypeShortCode: Yup.string().required('Ce champ est requis'),
        anomalyShortCode: Yup.string().required('Ce champ est requis'),
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
      })}
    />
  );
};

export default SecurityForms;
